var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pink-berry--text text-body-4"},[_vm._v(_vm._s(_vm.$t('cart.lowStock.availableStock', { stock: _vm.stock })))])}
var staticRenderFns = []

export { render, staticRenderFns }